module.exports = __webpack_public_path__ + "img/collection-engagementRingsExclusive.8ed6d12.jpg";